var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var EyeBlind = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 909.4 768", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M858.47 409.81l-106.84 78.35a479.35 479.35 0 0 1-283.85 92.92 483.2 483.2 0 0 1-60-3.75 32 32 0 0 0-8 63.5 548 548 0 0 0 68 4.25 543.35 543.35 0 0 0 321.7-105.31l106.84-78.35a32 32 0 1 0-37.85-51.61zM161.77 550.86a32 32 0 1 0 36-52.9c-4.65-3.18-9.32-6.47-13.86-9.8L77.08 409.8a32 32 0 0 1 0-51.6l106.84-78.36a480.33 480.33 0 0 1 343.86-89.17 32 32 0 1 0 8-63.5 543.65 543.65 0 0 0-389.7 101.06L39.23 306.59a96 96 0 0 0 0 154.82l106.85 78.36c5.14 3.77 10.42 7.5 15.69 11.09zM773.78 217.14a32 32 0 0 0-36 52.91c4.65 3.16 9.31 6.45 13.86 9.79l106.83 78.36a32 32 0 0 0 37.85-51.61l-106.84-78.36c-5.16-3.78-10.48-7.51-15.7-11.09zM842.4 9.37a32 32 0 0 0-45.25 0l-704 704a32 32 0 0 0 45.25 45.26l704-704a32 32 0 0 0 0-45.26z" }))))); };
export default EyeBlind;
//# sourceMappingURL=EyeBlind.js.map